/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod/v4";

export const contactMultiValueItemResponseDtoSchema = z.object({
    "order": z.number(),
"value": z.string(),
"label": z.string(),
"contact_signal_id": z.string(),
"appeared_at": z.iso.datetime(),
"updated_at": z.iso.datetime()
    })